<template>
  <div ref="circle-wrapper" class="menu-circle-wrapper">
    <span class="circle" :style="[{ top: `${top}px` }]"></span>
    <slot :calcPosition="calcPosition"></slot>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Object,
      default: {},
      required: true,
    },
    height: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      activeLink: 0,
      tempLink: undefined,
      menuHeight: this.height,
      top: 0,
    };
  },
  methods: {
    calcPosition(route) {
      this.tempLink = route;

      this.menuHeight = this.$refs["circle-wrapper"].clientHeight ? this.$refs["circle-wrapper"].clientHeight : this.height;

      this.top =
        this.tempLink === undefined
          ? (this.menuHeight / this.links.length) * this.activeLink + 20
          : (this.menuHeight / this.links.length) * this.tempLink + 20;
    },
  },
  mounted() {
    this.activeLink = this.links.findIndex((link) => link.is_active == true);

    // HACK submenu for career page
    if (this.activeLink === -1) {
      this.activeLink = 4
    }

    setTimeout(() => {
      this.calcPosition();
    }, 200);
  },
};
</script>

<style lang="scss">
@import "src/sass/mixins";
@import "src/sass/variables";
@import "node_modules/bootstrap/scss/vendor/rfs";

.menu-circle-wrapper {
  position: relative;

  .circle {
    position: absolute;
    top: 0;
    left: -4px;
    transform: translateY(-100%);
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: $white;
    transition: top 250ms ease-in-out;
  }
}
</style>